import { render, staticRenderFns } from "./dialog_release.vue?vue&type=template&id=058f9ba5&scoped=true&"
import script from "./dialog_release.vue?vue&type=script&lang=js&"
export * from "./dialog_release.vue?vue&type=script&lang=js&"
import style0 from "./dialog_release.vue?vue&type=style&index=0&id=058f9ba5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f9ba5",
  null
  
)

export default component.exports